__turbopack_context__.v({
  "legacyButton": "subscribeButton-module-scss-module__HLeZ4G__legacyButton",
});
